var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"mainArea"},[_c('router-link',{attrs:{"to":"/pc/see"}},[_vm._v("橙猩视点 > 详情")]),_c('div',{staticClass:"contentinfo"},[_c('iframe',{attrs:{"src":'https://mp.weixin.qq.com/s/'+_vm.id,"frameborder":"0","width":"100%","height":"500px"}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }